require('sass/brands/locations.wendys.com/location/default.scss');
require('js/location-script.js');
